import * as t from "io-ts";
export const nativeVersionResponseT = t.strict({
    android: t.string,
    ios: t.string,
});
//# sourceMappingURL=native-version.js.map